import React from 'react';
import { InlineMath } from 'react-katex';

/**
 * 수식 렌더링 공용 함수 (일반풀이 CBT / 모의고사·과목별 DiagnosticTest / 오답노트 공통).
 * - "$...$" 또는 "\( \)" 로 감싼 수식은 해당 부분만 렌더
 * - 구분자가 없어도 LaTeX 명령이 있고 한글이 없으면(순수 수식) 전체를 렌더
 *   (예: "E = \frac{\partial A}{\partial t}", "\text{rot } E = A" 처럼 변수로 시작)
 */
export function renderMathContent(text) {
  if (!text) return text;
  if (typeof text !== 'string') return text;

  try {
    if (!text.includes('$') && !text.includes('\\(')) {
      const hasLatex = /\\[a-zA-Z]+|[_^]\{/.test(text);
      const hasKorean = /[가-힣]/.test(text);
      if (hasLatex && !hasKorean) {
        return <InlineMath math={text} />;
      }
    }

    const parts = text.split(/(\$[^$]+\$|\\[(][^)]+\\[)])/);
    return (
      <span className="math-content">
        {parts.map((part, index) => {
          if (part.startsWith('$') && part.endsWith('$')) {
            return <InlineMath key={index} math={part.slice(1, -1)} />;
          } else if (part.startsWith('\\(') && part.endsWith('\\)')) {
            return <InlineMath key={index} math={part.slice(2, -2)} />;
          }
          return part;
        })}
      </span>
    );
  } catch (error) {
    console.warn('KaTeX 렌더링 오류:', error);
    return text;
  }
}

export default renderMathContent;
